import validate from "/usr/src/app/content/n3-spas-c3cb482a-90a6-45bc-a005-07201c1d407d/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-c3cb482a-90a6-45bc-a005-07201c1d407d/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}